import React from 'react'
import SliderStripe from '../SliderStripe'
import filterMoviesToday from '../functions/filterMoviesToday'


const CustomStripeSelection = ({ 
    currentActiveSelection, 
    setIdForActiveSelection, 
    selectionId, 
    itemSelection, 
    itemCollections, 
    translation, 
    stripeAppearance,
    moviesRoutesData, 
    features,
    ads, 
    movies, 
    sliderSettings, 
    routesData,
    addHtmlClass, 
    removeHtmlClass, 
    theme,
    nowObject
}) => {
    if(!itemSelection) {
        return ''
    }
    
    const { title, filterValue, filterType, style}  = itemSelection
    const collectionId = itemSelection.collections[0]
    const collectionItems = itemCollections[collectionId] && itemCollections[collectionId].items ? itemCollections[collectionId].items : []
    const items = 'moviesToday' === filterValue || 'moviesTodayByStart' === filterValue ? filterMoviesToday(collectionItems, movies, nowObject, translation.timezone, filterValue) : collectionItems

    return <SliderStripe
        stripeAppearance={stripeAppearance}
        title={title}
        items={items}
        theme={theme}
        filterValue={filterValue}
        filterType={filterType}
        moviesData={movies}
        moviesRoutesData={moviesRoutesData}
        routesData={routesData}
        translation={translation}
        adsData={ads}
        selectionStyle={style}
        scrollToPosition={'slider-movies slider-selection-movies ' + selectionId}
        settings={sliderSettings}
        features={features}
        addHtmlClass={addHtmlClass}
        removeHtmlClass={removeHtmlClass}
        currentActiveSelection={currentActiveSelection}
        setIdForActiveSelection={setIdForActiveSelection}
        isFront={true}
    />
}

export default CustomStripeSelection